const channelData = [
  {
    id: 17,
    title: "Quiero Música",
    img: "/images/tv/quiero_musica.jpeg",
    tag: "Entretenimiento",
    url: "https://www.youtube.com/watch?v=8Mw0YdKN2XY",
    url2: "",
  },
  {
    id: 2,
    title: "A 24 en vivo",
    img: "/images/tv/a24.png",
    tag: "noticias",
    url: "https://www.youtube.com/watch?v=ArKbAx1K-2U",
    url2: "",
  },

  {
    id: 4,
    title: "Canal Rural en vivo",
    img: "/images/tv/canal_rural.png",
    tag: "rural, campo",
    url: "https://www.youtube.com/watch?v=EED_GN6fuMQ",

  },

  {
    id: 5,
    title: "El doce en vivo",
    img: "/images/tv/el_doce.png",
    tag: "noticias, entretenimiento",
    url: "https://www.youtube.com/watch?v=nndzeKDSjuc",
    url2: "",
  },


  {
    id: 6,
    title: "TN en vivo",
    img: "/images/tv/tn.png",
    tag: "noticias",
    url2: "https://live-01-01-tn.vodgc.net/TN24/index.m3u8",
    url: "https://www.youtube.com/watch?v=cb12KmMMDJA",
  },

  {
    id: 7,
    title: "C5N en vivo",
    img: "/images/tv/c5n.png",
    tag: "noticias, entretenimiento",
    url: "https://www.youtube.com/watch?v=SF06Qy1Ct6Y",
    url2: "",
  },
  {
    id: 8,
    title: "La Nación + en vivo",
    img: "/images/tv/ln+.jpeg",
    tag: "noticias, entretenimiento",
    url: "https://www.youtube.com/watch?v=Hb0GIEL8nWc",
    url2: "",
  },

  {
    id: 9,
    title: "Crónica TV en vivo",
    img: "/images/tv/cronica.jpg",
    tag: "noticias",
    url: "https://www.youtube.com/watch?v=avly0uwZzOE&feature=youtu.be",
    url2: "",
  },

  {
    id: 12,
    title: "Telefe Noticias en vivo",
    img: "/images/tv/telefe.jpg",
    tag: "noticias",
    url: "https://www.youtube.com/watch?v=XhAYcYpPzTc",
    url2: "",
  },
  /*   {
      id: 13,
      title: "Radio con vos",
      img: "/images/tv/radio_convos.jpg",
      tag: "noticias",
      url: "https://www.youtube.com/watch?v=9aO6N-_uNco",
      url2: "",
    }, */


  {
    id: 14,
    title: "France 24 en vivo",
    img: "/images/tv/france.png",
    tag: "noticias, internacional",
    url: "https://www.youtube.com/embed/Y-IlMeCCtIg?hl=es&showinfo=0&color=white&rel=1&enablejsapi=1&origin=https%3A%2F%2Fwww.france24.com&autoplay=1&controls=1&modestbranding=0&disablekb=0&mute=0&playsinline=0&embed_config=%7B%22primaryThemeColor%22%3A%22%2300a7e3%22%2C%22relatedChannels%22%3A%5B%22UCUdOoVWuWmgo1wByzcsyKDQ%22%5D%2C%22autonavRelatedVideos%22%3Atrue%2C%22hideInfoBar%22%3Atrue%2C%22adsConfig%22%3A%7B%22disableAds%22%3Atrue%7D%2C%22enableIma%22%3Atrue%7D&widgetid=1",
    url2: "",
  },

  {
    id: 15,
    title: "Euronews en vivo",
    img: "/images/tv/euro.jpg",
    tag: "noticias, internacional",
    url: "https://www.youtube.com/watch?v=O9mOtdZ-nSk",
    url2: "",
  },

  {
    id: 16,
    title: "QVC Italia en vivo",
    img: "/images/tv/qvc.png",
    tag: "noticias, internacional, entretenimiento",
    url: "https://www.youtube.com/watch?v=jasW1vVhSSQ",
    url2: "",
  },
  /*   {
      id: 1,
      title: "24/7 Canal de Noticias en vivo",
      img: "/images/tv/247.png",
      tag: "noticias",
      url: "https://panel.host-live.com:19360/cn247tv/cn247tv.m3u8",
      url2: "",
    }, */


  {
    id: 19,
    title: "Radio Gol",
    img: "/images/tv/radio_gol_967.jpeg",
    tag: "radio online, deportes",
    url: "https://www.youtube.com/watch?v=3sKr72ZWAZI",
  },
  {
    id: 21,
    title: "Radio La Red",
    img: "/images/tv/la_Red.webp",
    tag: "radio online",
    url: "https://www.youtube.com/watch?v=OBySeVIQ2LQ",
  },
  {
    id: 22,
    title: "Cosmos TV",
    img: "/images/tv/COSMOS-TV.webp",
    tag: "entretenimiento, noticias",
    url: "https://tv.mediacp.eu:19360/cosmos/cosmos.m3u8",
    url2: "",
  },
  {
    id: 23,
    title: "Magic Kids",
    img: "/images/tv/magickid.png",
    tag: "infantiles, entretenimiento",
    url: "https://magicstream.ddns.net/magicstream/stream.m3u8",
    url2: "",
  },

];
module.exports = channelData;
